import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const AppMenuItemRoutes=({parentId,application,userData,parent})=>{
    const list_name='app_menu_item_routes';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'AppMenuItemRoute'}
                entityParams={['app_menu_item_id='+parentId]}
                list_name={list_name}
                height={'50vh'}
                file={'AppMenuItemRoutes.js'}
                navigateOnNew={null}
                canCreateNew={false}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={false}
                disableSelectionOnClick={false}
                popupComponent={null}
                parentContext={{
                    parent_field_name:'app_menu_item_id',
                    parent_field_value:null,
                    parent_name:'AppMenuItem',
                }}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return renderListTab;
}
export default AppMenuItemRoutes;
